import canUnitAnnexEntity from '../../entity/canUnitAnnexEntity'
import type { Entity } from '../../entity/index'
import type { AnnexableEntityList } from '../../state/AnnexableEntityList.type'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

export default function createAnnexListGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to enter a taxi
  unit: Entity
) {
  const data = new Array(gridWidth * gridHeight)
  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      const list : AnnexableEntityList = []
      if (positionStack) {
        for (let index = 0; index < positionStack.length; index++) {
          const entity = positionStack[index];
          if (canUnitAnnexEntity(unit, entity)) {
            list.push(entity)
          }
        }
      }
      data[index] = list
    }
  }
  return data
}
